import * as React from "react";
type Props = {
  className?: string,
};
function SvgStoveTop({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-StoveTop"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7406 19.1641C17.7406 20.8616 15.416 22.238 12.55 22.238C9.68292 22.238 7.35828 20.8616 7.35828 19.1641C7.35828 17.4667 9.68292 16.0902 12.55 16.0902C15.416 16.0902 17.7406 17.4667 17.7406 19.1641Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6861 10.5836C17.6861 11.9228 15.8531 13.0077 13.5917 13.0077C11.3304 13.0077 9.49731 11.9228 9.49731 10.5836C9.49731 9.24439 11.3304 8.15948 13.5917 8.15948C15.8531 8.15948 17.6861 9.24439 17.6861 10.5836Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.109 10.5836C31.109 11.9228 29.2759 13.0077 27.0146 13.0077C24.7532 13.0077 22.9202 11.9228 22.9202 10.5836C22.9202 9.24439 24.7532 8.15948 27.0146 8.15948C29.2759 8.15948 31.109 9.24439 31.109 10.5836Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.5764 19.1641C32.5764 20.8616 30.2518 22.238 27.3858 22.238C24.5187 22.238 22.1941 20.8616 22.1941 19.1641C22.1941 17.4667 24.5187 16.0902 27.3858 16.0902C30.2518 16.0902 32.5764 17.4667 32.5764 19.1641Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.3624 24.9307L32.6338 5.625H7.70241L1.5625 24.9341V34.817H38.3624V24.9307Z"
        stroke="currentColor"
      />
      <path d="M38.2736 25.1164H1.60596" stroke="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.1047 28.7119C34.7748 29.4996 34.6799 30.6828 33.8922 31.353C33.1034 32.0242 31.9213 31.9282 31.25 31.1405C30.5799 30.3517 30.6748 29.1696 31.4636 28.4994C31.6388 28.3502 31.832 28.2395 32.0366 28.1649C32.7508 27.905 33.5826 28.0982 34.1047 28.7119Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.72285 28.7119C9.393 29.4996 9.29807 30.6828 8.51038 31.353C7.72157 32.0242 6.53947 31.9282 5.86818 31.1405C5.19802 30.3517 5.29295 29.1696 6.08177 28.4994C6.25694 28.3502 6.45019 28.2395 6.65474 28.1649C7.36897 27.905 8.20073 28.0982 8.72285 28.7119Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1834 28.7119C17.8536 29.4996 17.7586 30.6828 16.971 31.353C16.1821 32.0242 15 31.9282 14.3288 31.1405C13.6586 30.3517 13.7535 29.1696 14.5423 28.4994C14.7175 28.3502 14.9108 28.2395 15.1153 28.1649C15.8295 27.905 16.6613 28.0982 17.1834 28.7119Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6441 28.7119C26.3143 29.4996 26.2193 30.6828 25.4317 31.353C24.6428 32.0242 23.4607 31.9282 22.7894 31.1405C22.1193 30.3517 22.2142 29.1696 23.003 28.4994C23.1782 28.3502 23.3715 28.2395 23.576 28.1649C24.2902 27.905 25.122 28.0982 25.6441 28.7119Z"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SvgStoveTop;
